import Carousel from "react-slick";
import { testimonialData } from "../../constant";
import TestimonialCard from "./TestimonialCard";
import withWindowDimensions from "../shared/withWindowDimensions";

const TestimonialSection = ({ isMobileSized }) => {
  const settings = {
    dots: true,
    infinite: false,
    speed: 1000,
    slidesToShow: 1.1,
    slidesToScroll: 1,
    arrows: true,
    autoplay: false,
    autoplaySpeed: 7000,
    responsive: [
      {
        breakpoint: 1300,
        settings: {
          arrow: false,
          nextArrow: <></>,
          prevArrow: <></>,
          dots: true,
        },
      },
      {
        breakpoint: 480,
        settings: {
          arrow: false,
          nextArrow: <></>,
          prevArrow: <></>,
          dots: true,
          autoplay: true,
        },
      },
    ],
  };
  return (
    <div
      style={
        !isMobileSized
          ? {
              display: "grid",
              gridTemplateColumns: "auto auto",
              gridGap: "40px",
            }
          : {}
      }
    >
      {isMobileSized ? (
        <Carousel {...settings}>
          {testimonialData.map((testimonial) => (
            <div key={testimonial.id} className="pr-2 md:pr-12 pl-6">
              <TestimonialCard {...testimonial} />
            </div>
          ))}
        </Carousel>
      ) : (
        testimonialData.map((testimonial) => (
          <div key={testimonial.id}>
            <TestimonialCard {...testimonial} />
          </div>
        ))
      )}

      <style jsx>{`
        :global(.slick-dots li button) {
          width: 24px; /* wider clickable area */
          height: 24px; /* taller clickable area */
          padding: 0;
        }

        :global(.slick-dots li button:before) {
          margin-top: 20px;
          font-size: 24px !important; /* bigger dots */
          color: gray;
          opacity: 1;
          line-height: 24px;
          /* Optionally scale */
          transform: scale(1.5);
          transition: color 0.3s ease;
        }

        :global(.slick-dots li.slick-active button:before) {
          color: #29bcb7 !important; /* active dot color */
          transform: scale(1.7);
        }
      `}</style>
    </div>
  );
};

export default withWindowDimensions(TestimonialSection);
